export * from './lib/rt-svg-sprite/rt-svg-sprite.module';
export * from './lib/rt-svg-sprite/components/rt-icon/rt-icon.component';
